import $ from 'jquery'
import axios from 'axios'
import { getArgsByGetParams } from './helpers'
import { fetchInstituteData, closeInstituteHandler, closeInstitute } from './institute-data'
// this is 
siteData.fetchInstituteData = fetchInstituteData

//const proxy = location.host.includes('local') || location.host.includes('upress') || location.host.includes('vangus') ? 'https://cors-anywhere.herokuapp.com/' : ''//
const proxy = ''// 'https://cors-anywhere.herokuapp.com/'

let globalResults
let loadMoreHandler
const resultsContainer = document.querySelector('.api-results')
const noResultsElement = document.querySelector('.api-results__no-results')
const loadMoreElement = document.querySelector('.api-results__load-more')
const numOfResultsElement = document.querySelector('.api-results__number')
const moreAccurateElement = document.querySelector('.api-results__more-accurate')
const loadingElement = document.querySelector('#loadin-results')

const buildQuery = () => {

    const apiForm = document.querySelector('.api-form')
    const submitButton = apiForm ? apiForm.querySelector('#api-search-submit') : null

    if (!(apiForm && submitButton))
        return

    /** makeRequest function also append the results */
    if (location.search) {
        const args = getArgsByGetParams()

        if (args) {
            makeRequest(args)
            openInstitute()
        }
    }

    /** */
    submitButton.addEventListener('click', e => {
        // remove previus event istener on load more
        //document.querySelector(".api-results__load-more").removeEventListener("click", loadMoreHandler);
        resultsContainer.innerHTML = ''
        noResultsElement.innerHTML = ''
        numOfResultsElement.innerHTML = ''
        moreAccurateElement.classList.remove('api-results__more-accurate--active')
        loadMoreElement.classList.remove('api-results__load-more--active')

        closeInstitute()
        const serArr = $(apiForm).serializeArray()
        const args = returnArgsFunc(serArr)
        makeRequest(args)
    })

    apiForm.addEventListener('submit', function (e) {
        e.preventDefault()
    })


    closeInstituteHandler()

}

export default buildQuery


// this function gettign array of objects like [ { name: 'City', value: '123', {...} } ]
// return args for the ajax request
const returnArgsFunc = serArr => {

    const args = {
        City: '',
        Coo: '',
        Seed: '',
        Text: '',
        Act: '',
        accH: '0',
        accO: '0',
        accD: '0',
        Year: 1,
        Area: '',
        // _search: false,
        // nd: 1547731836326,
        // rows: 15,
        // page: 1,
        // sidx: 'Name',
        // sord: 'desc',
    }

    serArr.forEach(element => {

        if (element.name in args) {

            if (element.name !== 'Act') {
                args[element.name] = element.value
            } else {
                args[element.name] += `${element.value},`
            }
        }
    })

    if (args['Act'][args['Act'].length - 1] === ',')
        args['Act'] = args['Act'].slice(0, -1);

    updateURLParams(args)

    return args

}

// push args to url
const updateURLParams = args => {
    let str = '?'
    for (let arg in args) {
        str += `${arg}=${args[arg]}&`
    }

    str = str.slice(0, -1)
    history.pushState(null, null, str)
}

/** Moved to helpers.js */
// const getArgsByGetParams = ()=> { ...

const makeRequest = args => {


    loadingElement && loadingElement.classList.add('loading--active')
    const resultsContainer = document.querySelector('.api-results')
    loadMoreElement.removeAttribute('style')

    axios.get(`${proxy}http://api.bat-ami.org.il/Api/Search/SearchInstitutes`, {
        params: args
    })
        .then(res => {
            console.log('Search Result', res)
            globalResults = res
            appendResults(globalResults)
            return globalResults
        })
        .catch(err => console.error(err))
}

const appendResults = (results) => {

    if (!results || !results.data || !results.data.length) {
        noResultsElement.classList.add('api-results__no-results--active')
        loadingElement.classList.remove('loading--active')
        return null
    } else {
        noResultsElement.classList.remove('api-results__no-results--active')
    }
    const total = results.data.length

    if (moreAccurateElement && total && total >= 100) {
        moreAccurateElement.classList.add('api-results__more-accurate--active')
    } else if (moreAccurateElement) {
        moreAccurateElement.classList.remove('api-results__more-accurate--active')
    }
    const numForPage = 10
    // const pageRegex = location.search.match(/page=(\d)/i)
    const haveMore = results.data.length > (numForPage - 1)

    numOfResultsElement ? numOfResultsElement.innerText = `${total} תוצאות נמצאו` : null
    appendSomeResults(results.data.slice(0, numForPage), resultsContainer)


    if (haveMore) {
        loadMoreElement.removeEventListener('click', loadMoreHandler, true)
        loadMore(results, numForPage, loadMoreElement, resultsContainer, noResultsElement)
        loadMoreElement.classList.add('api-results__load-more--active')
    }
}

const loadMore = (results, numForPage, loadMoreElement, resultsContainer, noResultsElement) => {
    const total = results.data.length
    let offset = numForPage
    let haveMore

    loadMoreHandler = (event) => {

        const resToAppend = results.data.slice(offset, offset + numForPage)
        offset += numForPage
        appendSomeResults(resToAppend, resultsContainer)
        haveMore = total > (offset - 1)

        haveMore || loadMoreElement.classList.remove('api-results__load-more--active')
    }

    loadMoreElement.addEventListener('click', loadMoreHandler, true)
}

const appendSomeResults = (resToAppend, resultsContainer) => {

    if (!resToAppend || !resToAppend.length) {
        document.querySelector('.api-results__no-results').classList.remove('api-results__no-results--active')
        return null
    }

    // loading animation
    loadingElement.classList.add('loading--active')

    let random = 0

    if (document.querySelector('.api-result')) {
        random = Math.ceil(Math.random() * (2100 - 1000) + 100)
    }

    setTimeout(() => {

        random = Math.ceil(Math.random() * (2100 - 1000) + 100)

        loadingElement.classList.remove('loading--active')

        // append 
        let html = (resToAppend && resToAppend.length) ? resToAppend.map(result => `
      <a href="javascript:void 0" onclick="siteData.fetchInstituteData(${result.Code})" data-institute-code="${result.Code}" class="api-result">
          <img src="${result.ImageLink ? 'http://api.bat-ami.org.il/Api/search/InstituteImage/' + result.Code : "https://via.placeholder.com/150X100"}" alt="${result.Name}" class="api-result__img">
          <div class="api-result__content">
              <h3 class="api-result__title${result.isPref ? ' pref' : ''}">${result.Name}</h3>
              <div class="api-result__location"><span><img class="api-result__icon" src="/wp-content/themes/batami/img/location.png"></span>${result.CityName}</div>
              <div class="api-result__field">
                  <span
                  class="api-result__category ${result.CategoryName === 'בת  עמי במיוחד' ? 'api-result__category--special' : ''}${result.CategoryName === 'בת עמי בקהילה' ? 'api-result__category--community' : ''}${result.CategoryName === 'בת עמי בחינוך' ? 'api-result__category--education' : ''}${result.CategoryName === 'בת עמי בהדרכה' ? 'api-result__category--counselor' : ''}${result.CategoryName === 'בת עמי בביטחון' ? 'api-result__category--security' : ''}"> 
                      ${result.CategoryName}
                  </span>
                  ${result.hasSeed ? `<span class="api-result__seed"><img class="api-result__icon" src="/wp-content/themes/batami/img/m1.png"></span>` : ''}
                  ${result.cHomePosts ? `<span class="api-result__home"><img class="api-result__icon" src="/wp-content/themes/batami/img/m2.png"></span>` : ''}
                  ${result.cOutPosts ? `<span class="api-result__apartment"><img class="api-result__icon" src="/wp-content/themes/batami/img/m3.png"></span>` : ''}
                  ${result.cDormitoryPosts ? `<span class="api-result__dormitory"><img class="api-result__icon" src="/wp-content/themes/batami/img/m4.png"></span>` : ''}
              </div>
          </div>
      </a>
    ` ).join('') : '<h3>אין תוצאות</h3>'

        resultsContainer.insertAdjacentHTML('beforeend', html)

    }, Math.random() * random)
}

const openInstitute = () => {
    let search = decodeURI(location.search)
    const regex = /institute=[0-9]+/
    const found = search.match(regex)

    found && window.scrollBy(0, 500)
    found && fetchInstituteData(found[0].match(/\d+/)[0])

}